import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  valeurPartagee: any;

  constructor() { }

  verified(tab:any,value:any){
    // Vérifie si la valeur existe dans le tableau
    if(tab.indexOf(value) !== -1){
      alert("La valeur existe!")
      return true
    } else{
      alert("La valeur n'existe pas!")
      return false
    }
  }

}
